/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('DOMContentLoaded', function () {
    const gstinInput = document.getElementById('gstin');
    const gstinError = document.getElementById('gstin-error');

    gstinInput.addEventListener('input', function () {
        const gstinPattern = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/;
        if (gstinPattern.test(gstinInput.value)) {
            gstinError.style.display = 'none';
        } else {
            gstinError.style.display = 'inline';
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const gstinInput = document.getElementById('gstin');
    const gstinError = document.getElementById('gstin-error');
    const stateInput = document.getElementById('state');

    const stateCodes = {
        '01': 'Jammu & Kashmir',
        '02': 'Himachal Pradesh',
        '03': 'Punjab',
        '04': 'Chandigarh',
        '05': 'Uttarakhand',
        '06': 'Haryana',
        '07': 'Delhi',
        '08': 'Rajasthan',
        '09': 'Uttar Pradesh',
        '10': 'Bihar',
        '11': 'Sikkim',
        '12': 'Arunachal Pradesh',
        '13': 'Nagaland',
        '14': 'Manipur',
        '15': 'Mizoram',
        '16': 'Tripura',
        '17': 'Meghalaya',
        '18': 'Assam',
        '19': 'West Bengal',
        '20': 'Jharkhand',
        '21': 'Odisha',
        '22': 'Chhattisgarh',
        '23': 'Madhya Pradesh',
        '24': 'Gujarat',
        '25': 'Daman and Diu',
        '26': 'Dadra and Nagar Haveli',
        '27': 'Maharashtra',
        '28': 'Andhra Pradesh',
        '29': 'Karnataka',
        '30': 'Goa',
        '31': 'Lakshadweep',
        '32': 'Kerala',
        '33': 'Tamil Nadu',
        '34': 'Puducherry',
        '35': 'Andaman and Nicobar Islands',
        '36': 'Telangana',
        '37': 'Andhra Pradesh (New)',
        '38': 'Ladakh'
    };

    gstinInput.addEventListener('input', function () {
        const gstinPattern = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/;
        const gstinValue = gstinInput.value;
        if (gstinPattern.test(gstinValue)) {
            gstinError.style.display = 'none';
            const stateCode = gstinValue.substring(0, 2);
            if (stateCodes[stateCode]) {
                stateInput.value = stateCodes[stateCode];
            } else {
                stateInput.value = '';
            }
        } else {
            gstinError.style.display = 'inline';
            stateInput.value = '';
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const gstinInput = document.getElementById('gstin');
    const gstinError = document.getElementById('gstin-error');
    const companyNameInput = document.getElementById('company-name');

    gstinInput.addEventListener('input', async function () {
        const gstinPattern = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/;
        const gstinValue = gstinInput.value;
        if (gstinPattern.test(gstinValue)) {
            gstinError.style.display = 'none';
            try {
                // Replace 'YOUR_API_URL' with the actual URL of the API that provides GSTIN details
                const response = await fetch(`https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/apiconnector/GSTValidate?gstin=${gstinValue}`);
                if (response.ok) {
                    const data = await response.json();
                    // Assuming the API returns a JSON object with a 'companyName' field
                    companyNameInput.value = data.companyName;
                    companyNameInput.readOnly = true;
                } else {
                    throw new Error('API request failed');
                }
            } catch (error) {
                console.error('Error fetching company name:', error);
                companyNameInput.value = '';
                companyNameInput.readOnly = false;
            }
        } else {
            gstinError.style.display = 'inline';
            companyNameInput.value = '';
            companyNameInput.readOnly = false;
        }
    });
});

